import { DEBUG, getBasicAuthData } from '../config/runtime';

interface FetchProps {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE';
  url: string;
  body?: {} | null;
}

interface FetchPropsIntl {
  url: string;
  options: RequestInit
}

const createOptions = ({ method, body }: { method: string, body: any }) => {
  const headers = new Headers({
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  });

  if (DEBUG) {
    const authKeyAndPass = getBasicAuthData();
    headers.append(authKeyAndPass[0], authKeyAndPass[1]);
  }

  const options: RequestInit = {
    body: JSON.stringify(body),
    credentials: 'same-origin', // Send cookies.
    headers,
    method,
  };

  return options;
};

export const fetchJson = <T>({ url, options } : FetchPropsIntl) => new Promise<T>((resolve, reject) => {
  fetch(url, options)
    .then((resp: Response) => {
      if (resp.status === 200) {
        resp.json()
          .then((json) => resolve(json))
          .catch((e) => reject(e));
      } else {
        const err = new Error(`HTTP status ${resp.status}`);
        err.response = resp;
        reject(err);
      }
    })
    .catch((e) => reject(e));
});

export const resolveJSON = <T>({ method, url, body }: FetchProps) => new Promise<T>((resolve, reject) => {
  const options = createOptions({ method, body });
  return fetchJson({ url, options });
});

const fetchResp = ({ url, options } : FetchPropsIntl) => new Promise<Response>((resolve, reject) => {
  fetch(url, options)
    .then((resp: Response) => { resolve(resp); })
    .catch((e) => reject(e));
});

export const resolveResp = ({ method, url, body }: FetchProps) => {
  const options = createOptions({ method, body });
  return fetchResp({ url, options });
};

export const post = (url: string, body?: any) => {
  const opts: RequestInit = {
    body: JSON.stringify(body),
    credentials: 'same-origin', // Send cookies.
    headers: new Headers({
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    }),
    method: 'POST',
  };

  return fetch(url, opts);
};

export const postResolveJSON = <T>(url: string, body?: any) => new Promise<T>((resolve, reject) => {
  const headers = new Headers({
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  });

  if (DEBUG) {
    const authKeyAndPass = getBasicAuthData();
    headers.append(authKeyAndPass[0], authKeyAndPass[1]);
  }

  const opts: RequestInit = {
    body: JSON.stringify(body),
    credentials: 'same-origin', // Send cookies.
    headers,
    method: 'POST',
  };

  fetch(url, opts)
    .then((resp: Response) => resp
      .json()
      .then((json) => resolve(json))
      .catch((e) => reject(e)))
    .catch((e) => reject(e));
});

export const getResolveJSON = <T>(url: string) => new Promise<T>((resolve, reject) => {
  const headers = new Headers({
    'X-Requested-With': 'XMLHttpRequest',
  });

  if (DEBUG) {
    const authKeyAndPass = getBasicAuthData();
    headers.append(authKeyAndPass[0], authKeyAndPass[1]);
  }

  const opts: RequestInit = {
    credentials: 'same-origin', // Send cookies.
    headers,
    method: 'GET',
  };

  fetch(url, opts)
    .then((resp: Response) => {
      if (resp.status === 401) {
        resolve({ object: 'error_auth' } as any);
        return;
      }

      resp
        .json()
        .then((json) => resolve(json))
        .catch((e) => reject(e));
    })
    .catch((e) => reject(e));
});
